import Toggleable from './Toggleable'

const DropdownMenuItem = Toggleable.MenuItem

export default DropdownMenuItem
